import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { Certification } from 'types/admin/modules';

export class EditCertificationService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  // TODO replace with the new prerequisites endpoint once it's ready
  getExistingCertifications = async () => {
    const response = await this.axiosInstance.get<Result<Certification[]>>(`/api/admin/courses`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching courses.');
  };
}
